import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Switcher = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 10C21.545 10 19.256 13.408 17.236 16.414C15.222 19.411 13.483 22 9 22H7.414C8.383 21.031 9.707 19.706 9.708 19.706C9.889 19.525 10 19.276 10 19C10 18.448 9.552 18 9 18C8.724 18 8.475 18.112 8.294 18.292L4.293 22.293C4.112 22.474 4 22.724 4 23C4 23.276 4.112 23.526 4.293 23.707L8.293 27.707C8.474 27.888 8.724 28 9 28C9.552 28 10 27.552 10 27C10 26.724 9.888 26.474 9.708 26.294C9.708 26.294 8.384 24.969 7.415 24H9.001C14.55 24 16.859 20.562 18.897 17.529C20.89 14.562 22.612 12 27.001 12C27.553 12 28.001 11.552 28.001 11C28.001 10.448 27.553 10 27.001 10H27Z" />
		<path d="M27 20C24.5 20 22.707 18.293 22.706 18.292C22.525 18.112 22.275 18 22 18C21.448 18 21 18.448 21 19C21 19.276 21.112 19.526 21.292 19.706C21.292 19.706 23.5 22 27 22C27.552 22 28 21.552 28 21C28 20.448 27.552 20 27 20Z" />
		<path d="M16.815 12.422C16.814 12.42 13.625 8 9 8H7.414C8.383 7.031 9.707 5.707 9.708 5.706C9.889 5.525 10 5.275 10 5C10 4.448 9.552 4 9 4C8.724 4 8.475 4.112 8.294 4.292L4.293 8.293C4.112 8.474 4 8.724 4 9C4 9.276 4.112 9.526 4.293 9.707L8.293 13.707C8.474 13.888 8.724 14 9 14C9.552 14 10 13.552 10 13C10 12.724 9.888 12.475 9.708 12.294C9.708 12.294 8.383 10.969 7.414 10H9C12.543 10 15.192 13.588 15.193 13.589C15.375 13.838 15.668 14 16 14C16.552 14 17 13.552 17 13C17 12.784 16.931 12.585 16.815 12.422Z" />
	</svg>
);

export default Switcher;
